var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/form-validation.j2"] = require( "macros/form-validation.j2" );
dependencies["personal-stylist/appointment-type.j2"] = require( "personal-stylist/appointment-type.j2" );
dependencies["personal-stylist/contact.j2"] = require( "personal-stylist/contact.j2" );
dependencies["personal-stylist/preferred-location.j2"] = require( "personal-stylist/preferred-location.j2" );
dependencies["personal-stylist/form-options-home.j2"] = require( "personal-stylist/form-options-home.j2" );
dependencies["personal-stylist/form-options-apparel.j2"] = require( "personal-stylist/form-options-apparel.j2" );
dependencies["personal-stylist/form-submit.j2"] = require( "personal-stylist/form-submit.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["help/templates/personal-stylist-form.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n";
env.getTemplate("macros/form-validation.j2", false, "help/templates/personal-stylist-form.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("displayFieldErrors")) {
var t_4 = t_1.displayFieldErrors;
} else {
cb(new Error("cannot import 'displayFieldErrors'")); return;
}
context.setVariable("displayFieldErrors", t_4);
if(t_1.hasOwnProperty("hasErrors")) {
var t_5 = t_1.hasErrors;
} else {
cb(new Error("cannot import 'hasErrors'")); return;
}
context.setVariable("hasErrors", t_5);
if(t_1.hasOwnProperty("validatedField")) {
var t_6 = t_1.validatedField;
} else {
cb(new Error("cannot import 'validatedField'")); return;
}
context.setVariable("validatedField", t_6);
if(t_1.hasOwnProperty("nonRequiredValidatedField")) {
var t_7 = t_1.nonRequiredValidatedField;
} else {
cb(new Error("cannot import 'nonRequiredValidatedField'")); return;
}
context.setVariable("nonRequiredValidatedField", t_7);
output += "\n\n<div class=\"c-personal-stylist dom-generic-email-service\">\n    ";
var t_8;
t_8 = "personal-styling";
frame.set("form_slug", t_8, true);
if(frame.topLevel) {
context.setVariable("form_slug", t_8);
}
if(frame.topLevel) {
context.addExport("form_slug", t_8);
}
output += "\n    ";
var t_9;
t_9 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs")),runtime.contextOrFrameLookup(context, frame, "form_slug"));
frame.set("emailFormConfig", t_9, true);
if(frame.topLevel) {
context.setVariable("emailFormConfig", t_9);
}
if(frame.topLevel) {
context.addExport("emailFormConfig", t_9);
}
output += "\n\n    <form novalidate data-form-slug=\"";
output += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "form_slug"), env.opts.autoescape);
output += "\" data-parsley-validate action=\"#\" method=\"post\" class=\"c-form js-generic-email-form\">\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"featureConfigs") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"brandCode") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"eid") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "emailFormConfig")),"sendToEmail")) {
output += "\n\n            ";
env.getTemplate("personal-stylist/appointment-type.j2", false, "help/templates/personal-stylist-form.j2", null, function(t_12,t_10) {
if(t_12) { cb(t_12); return; }
t_10.render(context.getVariables(), frame, function(t_13,t_11) {
if(t_13) { cb(t_13); return; }
output += t_11
output += "\n\n            ";
env.getTemplate("personal-stylist/contact.j2", false, "help/templates/personal-stylist-form.j2", null, function(t_16,t_14) {
if(t_16) { cb(t_16); return; }
t_14.render(context.getVariables(), frame, function(t_17,t_15) {
if(t_17) { cb(t_17); return; }
output += t_15
output += "\n\n            ";
env.getTemplate("personal-stylist/preferred-location.j2", false, "help/templates/personal-stylist-form.j2", null, function(t_20,t_18) {
if(t_20) { cb(t_20); return; }
t_18.render(context.getVariables(), frame, function(t_21,t_19) {
if(t_21) { cb(t_21); return; }
output += t_19
output += "\n\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService") && runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"appointmentType")) {
output += "\n\n                ";
var t_22;
t_22 = runtime.memberLookup((runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "core")),"genericEmailService")),"appointmentType");
frame.set("appointmentType", t_22, true);
if(frame.topLevel) {
context.setVariable("appointmentType", t_22);
}
if(frame.topLevel) {
context.addExport("appointmentType", t_22);
}
output += "\n\n                ";
if(runtime.contextOrFrameLookup(context, frame, "appointmentType") == "designCenter") {
output += "\n\n                    ";
env.getTemplate("personal-stylist/form-options-home.j2", false, "help/templates/personal-stylist-form.j2", null, function(t_25,t_23) {
if(t_25) { cb(t_25); return; }
t_23.render(context.getVariables(), frame, function(t_26,t_24) {
if(t_26) { cb(t_26); return; }
output += t_24
output += "\n\n                ";
})});
}
else {
output += "\n\n                    ";
env.getTemplate("personal-stylist/form-options-apparel.j2", false, "help/templates/personal-stylist-form.j2", null, function(t_29,t_27) {
if(t_29) { cb(t_29); return; }
t_27.render(context.getVariables(), frame, function(t_30,t_28) {
if(t_30) { cb(t_30); return; }
output += t_28
output += "\n\n                ";
})});
}
output += "\n\n            ";
;
}
output += "\n\n            ";
env.getTemplate("personal-stylist/form-submit.j2", false, "help/templates/personal-stylist-form.j2", null, function(t_33,t_31) {
if(t_33) { cb(t_33); return; }
t_31.render(context.getVariables(), frame, function(t_34,t_32) {
if(t_34) { cb(t_34); return; }
output += t_32
output += "\n\n        ";
})})})})})})})});
}
else {
output += "\n            <div class=\"o-row\">\n                <div class=\"o-column o-extra-small--12\">\n                    <div class=\"c-form__field has-error\">\n                        <div class=\"c-form-block\">\n                            <p class=\"c-form-block__p\">\n                                ";
output += runtime.suppressValue((lineno = 40, colno = 49, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "errorTranslation"), "errorTranslation", context, ["GENERIC_EMAIL_CONFIG_ERROR"])), env.opts.autoescape);
output += "\n                            </p>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        ";
;
}
output += "\n\n    </form>\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["help/templates/personal-stylist-form.j2"] , dependencies)